import { useTestAttrsFactory } from "utils/testid";
import { QUICK_CHECKOUT_CONFIRMING_MESSAGE } from "utils/quickCheckout";

type QuickCheckoutPendingProps = {
  message?: string | null;
};

/**
 * Quick checkout: the payment may have gone through but is not confirmed
 * yet (the card was charged and saving it failed, or the answer never came
 * back). There is deliberately no "try again": paying again could charge
 * the customer twice. The receipt email follows once it is confirmed.
 */
const QuickCheckoutPending = ({ message }: QuickCheckoutPendingProps) => {
  const testAttrs = useTestAttrsFactory();

  return (
    <div
      className="h-full flex items-center justify-center lg:pb-0 lg:pt-0 pt-5 pb-10"
      {...testAttrs("payment-pending", "Quick checkout payment being confirmed")}
    >
      <div className="w-full max-w-[630px] px-5 flex flex-col justify-center items-center gap-10">
        <div
          className="h-14 w-14 rounded-full border-4 border-solid border-blue border-r-transparent animate-spin motion-reduce:animate-none"
          aria-hidden="true"
        />
        <div
          className="w-full text-center text-xl text-txtPrimary font-medium"
          role="status"
        >
          We're confirming your payment
        </div>
        <div className="w-full text-center bg-bgThird lg:py-5 py-4 lg:px-2 px-3 lg:text-lg text-base text-txtParagraph break-words">
          {message || QUICK_CHECKOUT_CONFIRMING_MESSAGE}
        </div>
        <div className="w-full text-center text-txtParagraph lg:text-base text-sm">
          Please don't pay again. If no receipt arrives within a few minutes,
          contact us and we'll check the payment for you.
        </div>
      </div>
    </div>
  );
};

export default QuickCheckoutPending;
